module.exports = __webpack_public_path__ + "img/bluesky.e2f81fa8.svg";